module.exports = __webpack_public_path__ + "static/stardust-select-single-a9f2260d4fc4e9c2bd06395ce0e2d6e3.png";